export const ANNOTATION_FRAME = "1"
export const ANNOTATION_BBOX = "2"
export const ANNOTATION_SEG = "3"
export const ANNOTATION_KEYPOINT = "4"
